import { Input } from "antd";
import React from "react";
import { useTheme } from "styled-components";

const BCInputPassword = ({
  prefix,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
}) => {
  const theme = useTheme();

  return (
    <Input.Password
      prefix={prefix}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      style={{
        border: "none",
        outline: "none",
        boxShadow: "none",
        borderBottom: `1px solid ${theme.links}`,
        borderRadius: 0,
        borderBottomColor: "#cecaca",
      }}
    />
  );
};

export default BCInputPassword;
